import {
  SHOP_MANAGER_EDIT_SEARCH,
  SHOP_MANAGER_EDIT_SEARCH_FAILURE,
  SHOP_MANAGER_EDIT_SEARCH_SUCCESS,
  SHOP_MANAGER_UPDATE,
  SHOP_MANAGER_UPDATE_FAILURE,
  SHOP_MANAGER_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    shopManagers: [],
    shop: null
  },
  getters: {
    shopEditManagers: state => {
      return state.shopManagers
    },
    shopEditManagerShop: state => {
      return state.shop
    }
  },
  actions: {
    [SHOP_MANAGER_EDIT_SEARCH] ({dispatch, state, commit}, params = null) {
      var data = {}
      var url = '/master/shop_managers/' + params.id + '/edit'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_MANAGER_EDIT_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(SHOP_MANAGER_EDIT_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SHOP_MANAGER_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = {}
      var url = '/master/shop_managers/' + params.id
      var callback = () => {}
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_MANAGER_UPDATE_FAILURE, res.data)
          } else {
            commit(SHOP_MANAGER_UPDATE_SUCCESS, { data: data, callback: callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHOP_MANAGER_EDIT_SEARCH_FAILURE] (state, params) {
      console.log('SHOP_MANAGER_EDIT_SEARCH_FAILURE')
    },
    [SHOP_MANAGER_EDIT_SEARCH_SUCCESS] (state, params) {
      console.log('SHOP_MANAGER_EDIT_SEARCH_SUCCESS')
      var data = params.data
      state.shopManagers = data.users.data
      state.shop = data.shop.data
      if (params.callback) {
        params.callback()
      }
    },
    [SHOP_MANAGER_UPDATE_FAILURE] (state, params) {
      console.log('SHOP_MANAGER_UPDATE_FAILURE')
    },
    [SHOP_MANAGER_UPDATE_SUCCESS] (state, params) {
      console.log('SHOP_MANAGER_UPDATE_SUCCESS')
      if (params.callback) {
        params.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop-manager-edit.js